const KEYCLOAK_BASE_URL = `${process.env.VUE_APP_KEYCLOAK_AUTH_URL}/realms/${process.env.VUE_APP_KEYCLOAK_REALM}`

const Constants = {

    TOKEN_KEY: 'vue-token',
    REFRESH_TOKEN_KEY: 'vue-refresh-token',
    ALERT_TIMEOUT: 5000,
    TIMESLOT_WIDTH: 50,
    DOCKS_AUTO_REFRESH: 30000,

    STORE_ACTION_CREATE_ALERT: 'createAlert',
    STORE_ACTION_RESET_ALERT: 'removeAlert',
    STORE_MUTATION_ADD_ALERT: 'addAlert',
    STORE_MUTATION_RESET_ALERT: 'resetAlert',

    ERROR_PERMISSION_DENIED: 'You are not allowed to perform this action',
    ERROR_OVERLAP: 'There is already a visit in the selected timeslot',

    NAVIGATION_BAR_VISITS: 'visits',
    NAVIGATION_BAR_DOCKS: 'docks',
    NAVIGATION_BAR_ARRIVALS: 'arrivals',
    NAVIGATION_BAR_BOOKING: 'booking',
    NAVIGATION_BAR_SETTINGS: 'settings',

    STATUS_REQUESTED: 'Requested',
    STATUS_ACCEPTED: 'Accepted',
    STATUS_REJECTED: 'Rejected',

    ROLE_BOOKING_AGENT: 'Booking agent',
    ROLE_WAREHOUSE_PLANNER: 'Warehouse planner',
    ROLE_WAREHOUSE_MANAGEMENT: 'Warehouse management',
    ROLE_SUPER_USER: 'Super user',

    KEYCLOAK_AUTHORIZATION_ENDPOINT: `${KEYCLOAK_BASE_URL}/protocol/openid-connect/auth`,
    KEYCLOAK_END_SESSION_ENDPOINT: `${KEYCLOAK_BASE_URL}/protocol/openid-connect/logout`,
    KEYCLOAK_END_CHECK_SESSION_IFRAME_ENDPOINT: `${KEYCLOAK_BASE_URL}/protocol/openid-connect/login-status-iframe.html`,
    KEYCLOAK_ENDPOINT_TOKEN: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/auth/token`,
    KEYCLOAK_ENDPOINT_USERINFO: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/auth/userinfo`,

    ENDPOINT_ACCOUNT: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/account`,
    ENDPOINT_ACCOUNTS: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/accounts`,
    ENDPOINT_CUSTOMERS: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/customers`,
    ENDPOINT_REGIONS: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/regions`,
    ENDPOINT_BOOKINGS: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/bookings`,
    ENDPOINT_BOOKINGS_BY_LOCATION: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/bookings/byLocation`,
    ENDPOINT_ALL_BOOKINGS: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/bookings/all`,
    ENDPOINT_BOOKING_OPTIONS: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/booking-options`,
    ENDPOINT_BOOKING_OPTION: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/booking-option`,
    ENDPOINT_ENTITIES: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/entities`,
    ENDPOINT_STATUS: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/status`,
    ENDPOINT_ARRIVALS : `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/arrivals`,
    ENDPOINT_LOCATIONS: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/locations`,
    ENDPOINT_GROUPS: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/groups`,
    ENDPOINT_GROUP_BOOKINGS: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/group-bookings`,
    ENDPOINT_NOTIFICATIONS: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/notifications`,
    ENDPOINT_FILEHANDLER: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/filehandler`,
    ENDPOINT_GOS: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/gos/bookings`,
    ENDPOINT_ASSA_ABLOY: `${process.env.VUE_APP_BASE_URL}/pop/0.1.0/docks`
}

export { Constants }
